import {ExternalLookupIdentifier} from '@communicare/medications/Shared/SharedModels';
import { getApiConfig } from '../../config/api.config';
import { useSignalR } from './useSignalR';

export function usePharmacyRequestAddedSignalR(config: {
    patient: ExternalLookupIdentifier;
    onSignalResponse: (event: any) => void;
}) {
    var apiCcnfig = getApiConfig();
    let url = apiCcnfig.url.portal.replace(/\/+$/, "");
    return useSignalR<any>({
        endPointGroupName: `Patient-${config.patient.authoringSystem}-${config.patient.authoringSystemForeignKey}`.toLowerCase(),
        endPointHub: 'PharmacyRequestAdded',
        endPointUrl: `${url}/`,
        onSignalResponse: config.onSignalResponse
    });
}